import { AnswerStatus } from '../types/answer-status';
import { CHECKPOINTS_STATUS } from '../types/checkpoints-status';

export class StatusUtilities {
    public static getCheckpointStatusFromAnswers(answers: AnswerStatus): CHECKPOINTS_STATUS {
        const totalItems = answers.totalCheckpoints + answers.totalFunctionalElements;
        const totalAnsweredItems = answers.answeredCheckpoints + answers.answeredFunctionalElements;

        if (totalItems === 0) {
            return CHECKPOINTS_STATUS.NONE;
        } else if (totalAnsweredItems === 0) {
            return CHECKPOINTS_STATUS.EMPTY;
        } else if (totalAnsweredItems < totalItems && answers.answeredCheckpointsNotOK === 0) {
            return CHECKPOINTS_STATUS.PARTIALLY_FILLED;
        } else if (totalAnsweredItems < totalItems && answers.answeredCheckpointsNotOK > 0) {
            return CHECKPOINTS_STATUS.PARTIALLY_FILLED_NOT_OK;
        } else if (totalAnsweredItems === totalItems && answers.answeredCheckpointsNotOK === 0) {
            return CHECKPOINTS_STATUS.COMPLETELY_FILLED;
        } else if (totalAnsweredItems === totalItems && answers.answeredCheckpointsNotOK > 0) {
            return CHECKPOINTS_STATUS.COMPLETELY_FILLED_NOT_OK;
        } else {
            throw new Error(
                `ContentRendererComponent: contentStatus$: Could not calculate status of content: totalAnsweredItems ${totalAnsweredItems}, totalItems ${totalItems}`,
            );
        }
    }
}
